import React, { useContext } from "react";
import { ClientContext } from "../../context/Client/ClientContext";
import { GlobalContext } from "../../context/GlobalContext";

const LimitSearchHeader = () => {
  const { disableLimitBtns, address, toggleAddressForm } =
    useContext(GlobalContext);

  const {
    setLimitGiftcard,
    setOfferpromo,
    setHasWebstore,
    sellGiftcardsFilter,
    offerPromotion,
    hasWebstore,
  } = useContext(ClientContext);

  const formattedAddress = [
    address.country,
    address.province,
    address.city,
    address.postalCode,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="gog-limit-header">
      <div className="gog-search-by-title compact">
        <span>Filters</span>
        <h3>Limit Search To</h3>
        <p>
          Narrow your merchant search using location, gift card, promotion, and
          web store availability.
        </p>
      </div>

      <div className="gog-filter-location-row">
        <button
          type="button"
          onClick={() => toggleAddressForm()}
          disabled={disableLimitBtns}
          className="gog-secondary-btn"
        >
          Location
        </button>

        <div className="gog-location-summary">
          {formattedAddress || "No location selected"}
        </div>
      </div>

      <div className="gog-filter-list">
        <label className="gog-filter-toggle-row">
          <span>
            <strong>Gift Card</strong>
            <small>Show merchants that sell gift cards.</small>
          </span>

          <input
            type="checkbox"
            checked={sellGiftcardsFilter}
            onChange={(e) => setLimitGiftcard(e.target.checked)}
          />

          <i />
        </label>

        <label className="gog-filter-toggle-row">
          <span>
            <strong>Promo</strong>
            <small>Show merchants offering promotions.</small>
          </span>

          <input
            type="checkbox"
            checked={offerPromotion}
            onChange={(e) => setOfferpromo(e.target.checked)}
          />

          <i />
        </label>

        <label className="gog-filter-toggle-row">
          <span>
            <strong>Web Store</strong>
            <small>Show merchants with an online store.</small>
          </span>

          <input
            type="checkbox"
            checked={hasWebstore}
            onChange={(e) => setHasWebstore(e.target.checked)}
          />

          <i />
        </label>
      </div>
    </div>
  );
};

export default LimitSearchHeader;